module.exports = __webpack_public_path__ + "static/img/fit26.d1e59a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fc/fit26.png
// module id = idRd
// module chunks = 0